import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Divider, Grid, Space, Title} from "@mantine/core";
import {Footer} from "../../components/GetFooter";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {AccountModel} from "../../models/account/AccountModel";
import {useStyles} from "../../models/styles/NotFoundStyle";
import {IconDashboard, IconBrandGit, IconUsers} from "@tabler/icons-react";
import {DashboardItem} from "../../components/dashboard/DashboardItem";
import {HTTPError} from "../../models/errors/HTTPError";
import {No2FABanner} from "../../components/warnings/No2FABanner";

export function AccountDashboard({memory}: SystemMemoryProps) {
    const { classes } = useStyles();

    // Dashboard states
    const [name, setName] = useState('');
    const [banner, setBanner] = useState(<></>);
    const [admin, setAdmin] = useState(<></>);

    // Calculate the number of columns
    let cols = 2;
    if (window.innerWidth < 576) {
        cols = 1;
    }

    // Page loading function
    async function LoadAccountDashboard() {
        // Load the user's account dashboard
        const Api = new ApiDataHelper({memory: memory});

        let data = undefined;
        try {
            data = await Api.Execute<AccountModel>('/v1/account', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }, true, 120);
        }
        catch (e) {
            // Check for HttpError
            if (e instanceof HTTPError) {
                // If the user is not signed in, redirect to the login page
                if (e.code === 401) {
                    memory[0].Router('/login');
                }
                else {
                    // If the error has no method to handle it then throw it
                    throw e;
                }
            }
            else {
                // If the error is not an HTTPError then throw it
                throw e;
            }
        }

        if (data !== undefined) {
            // Set the user's name
            setName(data.firstName);

            // If the user doesn't have 2FA enabled, display a warning banner
            if (!data.has2FaEnabled) {
                setBanner(
                    <No2FABanner isAdmin={data.isAdmin}></No2FABanner>
                )
            }

            // Check if the user is an admin and has 2FA enabled
            if (data.isAdmin && data.has2FaEnabled) {
                setAdmin(
                    <>
                        <Divider size={5}></Divider><Space h="sm"/>
                        <Title order={2} className={classes.title}>Admin Controls</Title><Space h="sm"/>
                        <Grid columns={cols}>
                            <Grid.Col span={1}><Link style={{textDecoration: 'none'}} to="/admin/users">
                                <DashboardItem Icon={<IconUsers size={192} stroke={2}/>} Title={'Accounts'}
                                               Description={'Manage accounts and access codes.'}/>
                            </Link></Grid.Col>
                            <Grid.Col span={1}><Link style={{textDecoration: 'none'}} to="/admin/portfolio">
                                <DashboardItem Icon={<IconBrandGit size={192} stroke={2}/>} Title={'Portfolios'}
                                               Description={'Manage portfolios.'}/>
                            </Link></Grid.Col>
                        </Grid>
                    </>
                )
            }
        }
    }

    // Load the account dashboard
    React.useEffect(() => { LoadAccountDashboard() }, [])

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            <center>
                <Space h="lg" />
                {banner}
                <Title order={1} className={classes.title}>Welcome Back {name}!</Title>
                <Space h="lg" />
                <DashboardItem Icon={<IconDashboard size={192} stroke={2} />} Title={'Coming Soon!'} Description={'There is nothing here yet, but there will be soon!'} />
                <Space h="md" />
                {admin}
            </center>
            <Footer data={[]}></Footer>
        </>
    )
}